import { ITkFakeTableLineProps } from "../../type/componentsType/TkFakeTableLine";
import TkPropertyMessageGet from "../../utils/TkPropertyMessageGet";

/**
 * フェイクテーブルのリスト
 */
const fakeTableList: ITkFakeTableLineProps[] = [
  {
    title: "代行者名",
    keyword: "name",
    type: "name",
    requiredIcon: true,
  },
  {
    title: "メールアドレス",
    keyword: "email",
    type: "mail",
    requiredIcon: true,
    inputProps: [{ minLength: 1 }, { maxLength: 255 }],
  },
  {
    title: "メールアドレス（確認用）",
    keyword: "email2",
    type: "mail",
    requiredIcon: true,
    inputProps: [{ minLength: 1 }, { maxLength: 255 }],
  },
];
const schema = {
  name: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 48,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "47"),
    },
    pattern: {
      value: /^[^ -~｡-ﾟａ-ｚＡ-Ｚ]+$/,
      message: TkPropertyMessageGet("TKMSG_SCR0073E"),
    },
  },
  email: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 255,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "255"),
    },
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
  },
  email2: {
    required: TkPropertyMessageGet("TKMSG_SCR0043E"),
    maxLength: {
      value: 255,
      message: TkPropertyMessageGet("TKMSG_SCR0046E", "255"),
    },
    pattern: {
      value: /^[a-zA-Z0-9_.-]+@([a-zA-Z0-9-]*\.)+[a-z]{2,}$/,
      message: TkPropertyMessageGet("TKMSG_SCR0062E"),
    },
  },
};

export { schema, fakeTableList };
